// src/firebase.js
// ─── Firebase Analytics para Pura Ruta Landing ───────────────────────────────
// Usamos el SDK de npm (import), NO el CDN <script type="module">.
// Esto permite tree-shaking, env vars seguras y compatibilidad con React.
//
// 🔒 SEGURIDAD:
//   - La apiKey de Firebase Analytics es PÚBLICA por diseño de Google.
//   - Restringí la key en: console.cloud.google.com → APIs & Services →
//     Credentials → tu key → Application restrictions → HTTP referrers
//     → agregá *.pura-ruta.cr/* (tu dominio)
// ─────────────────────────────────────────────────────────────────────────────

import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            || 'AIzaSyBS8xR4fpyeWDnHD7f1N6w-snyBHgmCRB4',
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        || 'pura-ruta-cr.firebaseapp.com',
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         || 'pura-ruta-cr',
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     || 'pura-ruta-cr.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '155532137312',
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             || '1:155532137312:web:55d5c048080130e0990405',
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID     || 'G-M64LPJR0KX',
};

// Evitar inicializar múltiples veces en hot-reload de desarrollo
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// analytics puede no estar disponible en entornos sin window (SSR, bots)
let analyticsInstance = null;

export async function initAnalytics() {
  if (analyticsInstance) return analyticsInstance;
  const supported = await isSupported();
  if (supported) {
    analyticsInstance = getAnalytics(app);
  }
  return analyticsInstance;
}

/**
 * Registrá eventos custom de Analytics.
 * Ejemplos de uso:
 *   trackEvent('lead_submitted', { role: 'inversor' })
 *   trackEvent('cta_click',     { section: 'hero' })
 */
export async function trackEvent(eventName, params = {}) {
  const analytics = await initAnalytics();
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
}

export { app };
